import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-73005fcb"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "article-detail-page"
};
var _hoisted_2 = {
  "class": "container-fluid article-container mt--9"
};
var _hoisted_3 = {
  "class": "article-layout"
};
var _hoisted_4 = {
  "class": "article-main"
};
var _hoisted_5 = {
  "class": "bg-white border-0 article-header"
};
var _hoisted_6 = {
  "class": "article-title mb-3"
};
var _hoisted_7 = {
  "class": "article-meta-row d-flex align-items-center justify-content-between"
};
var _hoisted_8 = {
  "class": "article-author d-flex align-items-center"
};
var _hoisted_9 = {
  "class": "avatar rounded-circle mr-3"
};
var _hoisted_10 = ["alt", "src", "title"];
var _hoisted_11 = {
  "class": "d-flex"
};
var _hoisted_12 = {
  "class": "mb-0"
};
var _hoisted_13 = {
  "class": "el-tag el-tag--small el-tag--plain is-hit is-round ml-2"
};
var _hoisted_14 = {
  "class": "mb-0 text-gray"
};
var _hoisted_15 = {
  "class": "text-gray"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" in ");

var _hoisted_17 = {
  "class": "article-actions text-right d-flex"
};
var _hoisted_18 = {
  "class": "nav-link",
  href: "#commentCard"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "fa fa-comments"
  }, null, -1);
});

var _hoisted_20 = {
  "class": "nav-link-text ml-1"
};
var _hoisted_21 = ["href"];

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "fa fa-pencil"
  }, null, -1);
});

var _hoisted_23 = {
  "class": "nav-link-text ml-1"
};
var _hoisted_24 = {
  "class": "nav-link",
  href: "#"
};

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "fa fa-flag"
  }, null, -1);
});

var _hoisted_26 = {
  "class": "nav-link-text ml-1"
};
var _hoisted_27 = {
  "class": "article-body"
};
var _hoisted_28 = ["data-liker-id"];
var _hoisted_29 = {
  "class": "article-tags"
};
var _hoisted_30 = {
  "class": "bg-white border-0"
};
var _hoisted_31 = {
  key: 0,
  "class": "row"
};
var _hoisted_32 = {
  "class": "article-sidebar"
};
var _hoisted_33 = {
  "class": "recommend-card card shadow"
};
var _hoisted_34 = {
  "class": "card-header bg-white border-0"
};
var _hoisted_35 = {
  "class": "mb-0"
};
var _hoisted_36 = {
  "class": "text-muted text-sm mb-0"
};
var _hoisted_37 = {
  "class": "card-body"
};
var _hoisted_38 = ["href"];
var _hoisted_39 = ["src", "alt"];
var _hoisted_40 = {
  "class": "recommend-content"
};
var _hoisted_41 = {
  "class": "recommend-title"
};
var _hoisted_42 = {
  "class": "recommend-meta"
};
var _hoisted_43 = {
  key: 0,
  "class": "text-muted text-sm"
};
var _hoisted_44 = {
  "class": "container-fluid article-container mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;

  var _component_base_header = _resolveComponent("base-header");

  var _component_el_link = _resolveComponent("el-link");

  var _component_ReSteem = _resolveComponent("ReSteem");

  var _component_Markdown = _resolveComponent("Markdown");

  var _component_el_tag = _resolveComponent("el-tag");

  var _component_PostFootFunction = _resolveComponent("PostFootFunction");

  var _component_card = _resolveComponent("card");

  var _component_Comment = _resolveComponent("Comment");

  var _directive_wechat_title = _resolveDirective("wechat-title");

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_base_header, {
    type: "gradient-success",
    "class": "article-hero pb-6 pb-8 pt-5 pt-md-8"
  }), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("main", _hoisted_4, [_createVNode(_component_card, {
    shadow: "",
    type: "secondary",
    "class": "article-card"
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_5, [_createElementVNode("h1", _hoisted_6, _toDisplayString($data.blog.title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, [_createElementVNode("img", {
        alt: $data.userName,
        src: "https://steemitimages.com/u/".concat($data.blog.author, "/avatar"),
        title: $data.userName
      }, null, 8, _hoisted_10)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, [_createElementVNode("h3", _hoisted_12, [_createVNode(_component_el_link, {
        underline: false,
        type: "primary",
        href: "/@" + $data.blog.author,
        target: "_blank"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("@" + _toDisplayString($data.blog.author), 1)];
        }),
        _: 1
      }, 8, ["href"])]), _createElementVNode("span", _hoisted_13, _toDisplayString($options.getAccountReputation($data.blog.author_reputation)), 1)]), _createElementVNode("div", null, [_createElementVNode("h5", _hoisted_14, _toDisplayString($options.dateDiff($data.blog.created)), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_link, {
        underline: false,
        type: "primary",
        href: "/trending/" + $data.blog.community,
        target: "_blank"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($data.blog.community_title), 1)];
        }),
        _: 1
      }, 8, ["href"])])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString($data.blog.children), 1)]), $data.isAuthor ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        "class": "nav-link",
        href: "/post/" + $data.community + "/@" + $data.userName + "/" + _this.permlink
      }, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("button.edit")), 1)], 8, _hoisted_21)) : _createCommentVNode("", true), _createVNode(_component_ReSteem, {
        userName: $data.userName,
        permlink: $data.permlink
      }, null, 8, ["userName", "permlink"]), _createElementVNode("a", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("button.flag")), 1)])])])])];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_30, [$data.blog.title ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_PostFootFunction, {
        blogs: $data.blog,
        isShowComment: false
      }, null, 8, ["blogs"])])) : _createCommentVNode("", true)])];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_27, [_createVNode(_component_Markdown, {
        text: $data.blog.body
      }, null, 8, ["text"])]), $data.likeid ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "likecoin-embed likecoin-button",
        "data-liker-id": $data.likeid
      }, null, 8, _hoisted_28)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tags, function (item) {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: item,
          "class": "mr-2 mb-2"
        }, {
          "default": _withCtx(function () {
            return [_createVNode(_component_el_link, {
              underline: false,
              type: "primary",
              href: "/trending/" + item,
              target: "_blank"
            }, {
              "default": _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item), 1)];
              }),
              _: 2
            }, 1032, ["href"])];
          }),
          _: 2
        }, 1024);
      }), 128))])];
    }),
    _: 1
  })]), _createElementVNode("aside", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.$t("label.recommendedReading")), 1), _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("label.sameCommunityPosts")), 1)]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommendedBlogs, function (item) {
    return _openBlock(), _createElementBlock("a", {
      key: item.author + '/' + item.permlink,
      "class": "recommend-item",
      href: $options.buildArticleUrl(item)
    }, [_createElementVNode("img", {
      "class": "recommend-thumb",
      src: $options.getRecommendImage(item),
      alt: item.title
    }, null, 8, _hoisted_39), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_42, " @" + _toDisplayString(item.author) + " · " + _toDisplayString($options.dateDiff(item.created)), 1)])], 8, _hoisted_38);
  }), 128)), !$data.recommendedBlogs.length ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t("label.noRecommendedPosts")), 1)) : _createCommentVNode("", true)])])])])], 512), [[_vShow, $data.blog.author]]), _withDirectives(_createElementVNode("div", _hoisted_44, [_createVNode(_component_card, {
    shadow: "",
    type: "secondary",
    id: "commentCard",
    "class": "comment-card"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_Comment, {
        data: $data.data,
        "onUpdate:data": _cache[0] || (_cache[0] = function ($event) {
          return $data.data = $event;
        }),
        user: $data.currentUser,
        "before-submit": $options.submit,
        "before-like": $options.like,
        "before-delete": _ctx.deleteComment,
        "upload-img": _ctx.uploadImg,
        rootPost: $data.rootPost,
        props: $data.props
      }, null, 8, ["data", "user", "before-submit", "before-like", "before-delete", "upload-img", "rootPost", "props"])];
    }),
    _: 1
  })], 512), [[_vShow, $data.blog.author]])])), [[_directive_wechat_title, ($data.blog.title || '') + '|BoyLikeGirlClub']]);
}